import axios from "axios";
import { API_ENDPOINTS } from "../config/endpoints";

// Create a separate axios instance for public API calls (no auth required)
const publicApiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getCateringOrderStatusPublic = async (orderNo, referenceNumber) => {
  try {
    const response = await publicApiClient.post(API_ENDPOINTS.CATERING_ORDER_STATUS, {
      order_no: orderNo,
      reference_number: referenceNumber
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching catering order status (public):", error);
    throw error;
  }
};
